import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { HERO_LINES, PROFILE } from "../data/work";

const ease = [0.22, 1, 0.36, 1];

const Line = ({ children, delay }) => (
  <span className="line-mask">
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [0, 160]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section
      ref={ref}
      data-testid="hero-section"
      className="relative min-h-[100svh] flex flex-col justify-end px-5 md:px-12 pb-14 md:pb-20 pt-28 overflow-hidden"
    >
      {/* top meta row */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 1 }}
        className="absolute top-24 md:top-28 left-5 md:left-12 right-5 md:right-12 flex justify-between text-xs md:text-sm uppercase tracking-[0.2em] text-muted2"
      >
        <span>{PROFILE.role}</span>
        <span className="hidden sm:inline">{PROFILE.location}</span>
      </motion.div>

      <motion.div style={{ y, opacity }}>
        <h1 className="font-serif font-semibold text-ink leading-[1.02] tracking-[-0.02em] text-[13vw] md:text-[8.5vw] lg:text-[8vw]">
          <Line delay={0.5}>{HERO_LINES[0]}</Line>
          <Line delay={0.62}>{HERO_LINES[1]}</Line>
          <Line delay={0.74}>
            And <span className="italic text-vermilion">reality.</span>
          </Line>
        </h1>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.3, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 md:mt-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6 max-w-[1600px]"
        >
          <p className="max-w-xl text-base md:text-lg text-muted2 leading-relaxed">
            A copywriter-turned-strategist shaping positioning and campaigns for
            LocoBear, Godrej, Ownly and more.
          </p>
          <button
            data-testid="hero-scroll-cue"
            onClick={() =>
              window.__lenis
                ? window.__lenis.scrollTo("#work", { offset: -20 })
                : document.getElementById("work")?.scrollIntoView({ behavior: "smooth" })
            }
            className="group inline-flex items-center gap-3 text-sm uppercase tracking-[0.2em] text-ink"
          >
            <span className="link-underline py-1">Selected Work</span>
            <span className="inline-block transition-transform duration-300 group-hover:translate-y-1">↓</span>
          </button>
        </motion.div>
      </motion.div>
    </section>
  );
}
